import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, createBlock as _createBlock, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withModifiers as _withModifiers, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "main-content type4" };
const _hoisted_2 = {
    key: 0,
    "no-gutters": "",
    class: "my-4 d-flex align-center justify-end"
};
const _hoisted_3 = {
    key: 0,
    class: "mt-4"
};
import { computed, onBeforeMount, ref, reactive, onBeforeUnmount, watch, } from 'vue';
import { i18n } from '@/locales';
import { injectSeparatorDateString } from '@/utils';
import { componentInfo } from '@/constants/userManagement/options';
import { userPermission } from '@/constants';
import { errorCode } from '@/error';
import { pageTypeList } from '@/constants/userManagement/pageTypeList';
import createUserManagementFormData from '@/form/form-data/createUserManagementFormData';
import createUserFormRules from '@/form/form-rules/userManagement';
import { useRoute, useRouter, } from 'vue-router';
import { getGlobalStore } from '@/lib/global-store';
import CardSection from '@/components/Common/CardSection.vue';
import { routeName } from '@/constants/routeName';
import { alertActionType } from '@/vuex-store/alert/actions';
import { snackbarActionType } from '@/vuex-store/snackbar/actions';
import { objDeepCompare } from '@/utils/object';
import UserBasicInfo from './BasicInfo.vue';
const formRulesLc = 'form_rules.';
const lc = 'views.user_management.';
const userPageLc = 'views.user_management_page.';
export default /*@__PURE__*/ _defineComponent({
    __name: 'index',
    setup(__props) {
        const getComp = (n) => ({
            UserBasicInfo,
        }[n]);
        const route = useRoute();
        const router = useRouter();
        const vuexStore = getGlobalStore();
        // store 관리
        const type = computed(() => vuexStore.state.userManagement.userPage.type);
        const userDetail = computed(() => vuexStore.state.userManagement.userPage.userDetail);
        const getterUserId = computed(() => vuexStore.getters['userManagement/userPage/getterUserId']);
        const getterUserDetail = computed(() => vuexStore.getters['userManagement/userPage/getterUserDetail']);
        const isType = (selectedType) => selectedType === type.value;
        const isTypeCreate = ref(false);
        const inputRowCss = ref('');
        const formRules = createUserFormRules(formRulesLc);
        const formRef = ref(null);
        const formValid = ref(false);
        const createdFormData = createUserManagementFormData();
        const createdOriginFormData = createUserManagementFormData();
        const formData = reactive(createdFormData);
        const originFormData = reactive(createdOriginFormData);
        const getterUserPermission = computed(() => vuexStore.getters['user/getterUserPermission']);
        const isVisibleEditBtn = computed({
            get() {
                const permission = getterUserPermission.value([
                    userPermission.P_EDIT_USER,
                ]);
                const isDetail = type.value === pageTypeList.DETAIL.value;
                return permission && isDetail;
            },
            set() { },
        });
        const resetFormData = () => {
            const isEditPage = isType(pageTypeList.BASIC_INFO.value);
            if (!isEditPage) {
                return;
            }
            Object.assign(formData, createUserManagementFormData());
        };
        const initFormData = () => {
            if (isTypeCreate.value) {
                return;
            }
            Object.entries(getterUserDetail.value).reduce((acc, [key, value]) => {
                if (!value) {
                    return acc;
                }
                const replacedKey = key.replace('_', '');
                if (replacedKey === 'hubDTO') {
                    acc.hubName = value.name;
                    return acc;
                }
                if (replacedKey === 'resignationAt') {
                    acc.resignationAt = injectSeparatorDateString(value);
                    return acc;
                }
                acc[replacedKey] = value;
                return acc;
            }, formData);
            Object.assign(originFormData, formData);
        };
        const createErrorMessageData = () => ({
            userIdExistence: '',
            isSameIdAndPassword: '',
        });
        const initErrorMessageData = createErrorMessageData();
        const errorMessageData = reactive(initErrorMessageData);
        const contentWrapper = computed({
            get() {
                return {
                    'view-wrapper': isType(pageTypeList.DETAIL.value),
                    'create-wrapper': isType(pageTypeList.CREATE.value)
                        || isType(pageTypeList.BASIC_INFO.value),
                };
            },
            set() { },
        });
        const isFormValid = (errorMessages) => {
            const messageList = [
                i18n.t('common.form_validation_error'),
            ];
            const isValidData = formRef.value?.validate();
            const isErrorMessageExist = Object.values(errorMessages).some((message) => !!message);
            if (isValidData && !isErrorMessageExist) {
                return true;
            }
            vuexStore.dispatch(snackbarActionType.showError, {
                message: messageList,
            });
            return false;
        };
        const _resetValidation = () => formRef.value.resetValidation();
        const pageRoute = (name, param) => {
            router
                .push({
                name,
                params: {
                    userId: getterUserId.value,
                    pageType: param,
                },
                query: route.query,
            })
                .catch(() => { });
        };
        const goToPreviousPage = () => {
            const isEditPage = type.value === pageTypeList.BASIC_INFO.value;
            if (isEditPage) {
                return pageRoute(routeName.USER_MANAGEMENT_PAGE, pageTypeList.DETAIL.value);
            }
            return pageRoute(routeName.USER_MANAGEMENT);
        };
        const _onSubmit = async (submitData) => {
            try {
                let response;
                const filteredData = submitData;
                if (type.value === pageTypeList.CREATE.value) {
                    delete filteredData.resignationAt;
                    filteredData.useYn = 'Y'; // 안보내면 에러나기때문에 고정으로 보냄
                    response = await vuexStore.dispatch('userManagement/userPage/postUser', submitData);
                }
                if (type.value === pageTypeList.BASIC_INFO.value) {
                    delete filteredData.userId;
                    delete filteredData.password;
                    delete filteredData.hubId;
                    delete filteredData.level;
                    response = await vuexStore.dispatch('userManagement/userPage/putUser', {
                        userId: getterUserId.value,
                        data: submitData,
                    });
                }
                if (!response.isSuccess) {
                    if (response.reason || response.message) {
                        return vuexStore.dispatch(snackbarActionType.showError, {
                            message: errorCode[response.reason] ?? response.message,
                        });
                    }
                    return vuexStore.dispatch(snackbarActionType.showError, {
                        message: i18n.t('common.unknown_error'),
                    });
                }
                goToPreviousPage();
                return vuexStore.dispatch(snackbarActionType.showSuccess, {
                    message: i18n.t(isType(pageTypeList.CREATE.value)
                        ? `${lc}create_user_info_success`
                        : `${lc}edit_user_info_success`),
                });
            }
            catch (error) {
                console.log('userManagement/userPage/handleSubmitForm', error);
                return vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.failure'),
                });
            }
        };
        const saveBtnText = computed({
            get() {
                if (isType(pageTypeList.CREATE.value)) {
                    return 'common.registration';
                }
                return 'common.save';
            },
            set() { },
        });
        const handleClickReturnBtn = () => {
            goToPreviousPage();
        };
        const handleClickEditBtn = async () => {
            const { userId } = route.params;
            router
                .push({
                name: routeName.USER_MANAGEMENT_PAGE,
                params: {
                    pageType: pageTypeList.BASIC_INFO.value,
                    userId,
                },
                query: route.query,
            })
                .catch(() => { });
            initFormData();
        };
        const handleSubmitForm = () => {
            const isValid = isFormValid(errorMessageData);
            if (!isValid) {
                return vuexStore.dispatch(snackbarActionType.showError, {
                    message: i18n.t('common.form_validation_error'),
                });
            }
            return _onSubmit(formData);
        };
        const handleClickCancelForm = async () => {
            const isSameData = objDeepCompare(originFormData, formData);
            if (isSameData) {
                goToPreviousPage();
                resetFormData();
                return;
            }
            const title = isType(pageTypeList.CREATE.value)
                ? `${i18n.t(`${userPageLc}cancel_create_basic_info`)}`
                : `${i18n.t(`${userPageLc}cancel_edit_basic_info`)}`;
            const isConfirmOk = await vuexStore.dispatch(alertActionType.confirm, {
                headerTitle: title,
                bodyContent: i18n.t('common.confirm_before_cancel'),
                btnConfig: [
                    {
                        text: 'cancel',
                        cssClass: 'outlined info',
                    },
                    {
                        text: 'ok',
                        cssClass: 'danger',
                    },
                ],
            });
            if (isConfirmOk) {
                goToPreviousPage();
                resetFormData();
            }
        };
        // 페이지 타입 확인 (create, basic-info / detail 카드 넓이 조절필요)
        const getPageType = () => {
            const { pageType } = route.params;
            // @ts-ignore
            vuexStore.dispatch('userManagement/userPage/setPageType', pageType);
        };
        const callApi = async (pageType, userId) => {
            const needUserInfo = [
                pageTypeList.DETAIL.value,
                pageTypeList.BASIC_INFO.value,
            ];
            const needHubList = [
                pageTypeList.BASIC_INFO.value,
                pageTypeList.CREATE.value,
            ];
            if (needUserInfo.includes(pageType)) {
                // @ts-ignore
                await vuexStore.dispatch('userManagement/userPage/getUser', userId);
                initFormData();
            }
            if (needHubList.includes(pageType)) {
                await vuexStore.dispatch('userManagement/userPage/getHubList');
            }
        };
        // api 호출
        const initPage = async () => {
            const { userId, pageType } = route.params;
            await callApi(pageType, userId);
            vuexStore.dispatch('app/setPageTitle');
        };
        onBeforeMount(() => {
            getPageType();
            initPage();
        });
        onBeforeUnmount(() => {
            _resetValidation();
            // @ts-ignore
            vuexStore.dispatch('userManagement/userPage/resetUserDetail');
        });
        watch(() => route.params.pageType, async () => {
            const { pageType, userId } = route.params;
            // @ts-ignore
            await vuexStore.dispatch('userManagement/userPage/setPageType', pageType);
            inputRowCss.value = pageType === pageTypeList.DETAIL.value
                ? 'brg-input-section-dense-wrapper'
                : '';
            await callApi(pageType, userId);
            isTypeCreate.value = pageType === pageTypeList.CREATE.value;
        }, {
            immediate: true,
        });
        const cardStyle = computed({
            get() {
                return {
                    'view-content-card': type.value === pageTypeList.DETAIL.value,
                    'editable-content-card': [
                        pageTypeList.CREATE.value,
                        pageTypeList.BASIC_INFO.value,
                    ].includes(type.value),
                };
            },
            set() { },
        });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_form = _resolveComponent("v-form");
            const _component_v_icon = _resolveComponent("v-icon");
            const _directive_btn_style = _resolveDirective("btn-style");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createVNode(_component_v_form, {
                    ref_key: "formRef",
                    ref: formRef,
                    modelValue: formValid.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((formValid).value = $event)),
                    class: _normalizeClass(contentWrapper.value),
                    onSubmit: _withModifiers(handleSubmitForm, ["prevent"])
                }, {
                    default: _withCtx(() => [
                        _createElementVNode("div", {
                            class: _normalizeClass(cardStyle.value)
                        }, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(componentInfo), ({ title, componentName }) => {
                                return (_openBlock(), _createBlock(CardSection, {
                                    key: title,
                                    title: title
                                }, {
                                    titleContent: _withCtx(() => [
                                        (isVisibleEditBtn.value)
                                            ? _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                                key: 0,
                                                class: "option-ctrl-area",
                                                variant: "elevated",
                                                "prepend-icon": "mdi-pencil-outline",
                                                onClick: handleClickEditBtn
                                            }, {
                                                default: _withCtx(() => [
                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.modify')), 1 /* TEXT */)
                                                ]),
                                                _: 1 /* STABLE */
                                            })), [
                                                [
                                                    _directive_btn_style,
                                                    void 0,
                                                    "config",
                                                    {
                                                        info: true,
                                                        outlined: true,
                                                        "size-m": true
                                                    }
                                                ]
                                            ])
                                            : _createCommentVNode("v-if", true)
                                    ]),
                                    default: _withCtx(() => [
                                        (_openBlock(), _createBlock(_resolveDynamicComponent(getComp(componentName)), {
                                            type: type.value,
                                            "user-detail": userDetail.value,
                                            lc: lc,
                                            "user-page-lc": userPageLc,
                                            "form-data": formData,
                                            "origin-form-data": originFormData,
                                            "form-rules": _unref(formRules),
                                            "form-rules-lc": formRulesLc,
                                            "error-message-data": errorMessageData,
                                            "input-row-css": inputRowCss.value,
                                            onInitFormData: initFormData
                                        }, null, 40 /* PROPS, NEED_HYDRATION */, ["type", "user-detail", "form-data", "origin-form-data", "form-rules", "error-message-data", "input-row-css"]))
                                    ]),
                                    _: 2 /* DYNAMIC */
                                }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["title"]));
                            }), 128 /* KEYED_FRAGMENT */))
                        ], 2 /* CLASS */),
                        (!isType(_unref(pageTypeList).DETAIL.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                                    class: "mr-2",
                                    onClick: handleClickCancelForm
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            info: true,
                                            outlined: true,
                                            "width-xs": true,
                                            "size-l": true
                                        }
                                    ]
                                ]),
                                _withDirectives((_openBlock(), _createBlock(_component_v_btn, { type: "submit" }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t(saveBtnText.value)), 1 /* TEXT */)
                                    ]),
                                    _: 1 /* STABLE */
                                })), [
                                    [
                                        _directive_btn_style,
                                        void 0,
                                        "config",
                                        {
                                            primary: true,
                                            "width-xs": true,
                                            "size-l": true
                                        }
                                    ]
                                ])
                            ]))
                            : _createCommentVNode("v-if", true)
                    ]),
                    _: 1 /* STABLE */
                }, 8 /* PROPS */, ["modelValue", "class"]),
                (isType(_unref(pageTypeList).DETAIL.value))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
                            class: "list-btn",
                            onClick: handleClickReturnBtn
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_v_icon, { small: "" }, {
                                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                                        _createTextVNode(" mdi-chevron-left ")
                                    ])),
                                    _: 1 /* STABLE */,
                                    __: [1]
                                }),
                                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.back_to_list')), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                        })), [
                            [
                                _directive_btn_style,
                                void 0,
                                "config",
                                {
                                    info: true,
                                    outlined: true,
                                    "size-l": true,
                                    "width-xs": true
                                }
                            ]
                        ])
                    ]))
                    : _createCommentVNode("v-if", true)
            ]));
        };
    }
});
